import React from 'react'

const serviceoption = () => {
    
  return (
    <div className='Services'>
        <div className='container'>
            <div className='row' >
                <div className='col-md-3 section'>
                    <div className='Picture'>
                        <i class="fa-solid fa-truck"></i>
                    </div>
                    <div className='Texts'>
                        <h4>Product Delivery</h4>
                        <p>Fast and Free Shipping</p>
                    </div>
                </div>
                <div className='col-md-3 section'>
                    <div className='picture'>
                            <i class="fa-solid fa-tags"></i>
                        </div>
                        <div className='Texts'>
                            <h4>Our Offers</h4>
                            <p>Provide Offer on occasions</p>
                        </div>
                </div>
                <div className='col-md-3 section'>
                    <div className='picture'>
                        <i class="fa-solid fa-truck"></i>
                    </div>
                    <div className='Texts'>
                        <h4>Product Delivery</h4>
                        <p>Fast and Free Shipping</p>
                    </div>
                </div>
                <div className='col-md-3 section'>
                    <div className='picture'>
                        <i class="fa-solid fa-tags"></i>    
                    </div>
                    <div className='Texts'>
                        <h4>Our Offers</h4>
                        <p>Provide Offer on occasions</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default serviceoption